/**
 * PATH: packages/ui/src/qa/QaItemChangeBanner.tsx
 * FILE_ID: FE-QA-ITEM-CHANGE-BANNER-001
 * PURPOSE: Shared pending edit/delete request state for both QA doors.
 * WHY: Jobs tab and QA hub must show the same pending request + owner
 *      approve/reject controls. @quotech/ui is the only package both import.
 */
import { Loader2 } from 'lucide-react'

export interface QaItemChangeBannerProps {
  kind: 'edit' | 'delete'
  canApprove?: boolean
  busy?: boolean
  onApprove?: () => void | Promise<void>
  onReject?: () => void | Promise<void>
  className?: string
}

export function QaItemChangeBanner({
  kind,
  canApprove = false,
  busy = false,
  onApprove,
  onReject,
  className,
}: QaItemChangeBannerProps) {
  const label = kind === 'delete' ? 'Delete requested' : 'Edit requested'
  return (
    <div
      className={
        className ??
        'mt-2 flex flex-wrap items-center gap-2 rounded-lg border border-amber-400/40 bg-amber-50 px-2.5 py-1.5 text-xs text-amber-800 dark:bg-amber-950/30 dark:text-amber-200'
      }
    >
      <span>{label}. Waiting on the job owner.</span>
      {canApprove && (
        <span className="ml-auto flex items-center gap-1.5">
          <button
            type="button"
            disabled={busy}
            onClick={() => void onApprove?.()}
            className="rounded-md bg-emerald-600 px-2 py-1 text-[11px] font-medium text-white disabled:opacity-50"
          >
            {busy ? <Loader2 className="h-3 w-3 animate-spin" aria-hidden /> : 'Approve'}
          </button>
          <button
            type="button"
            disabled={busy}
            onClick={() => void onReject?.()}
            className="rounded-md border border-border px-2 py-1 text-[11px] font-medium disabled:opacity-50"
          >
            Reject
          </button>
        </span>
      )}
    </div>
  )
}
